import { render, staticRenderFns } from "./CreatedInvoice.vue?vue&type=template&id=16a50787&scoped=true&"
import script from "./CreatedInvoice.vue?vue&type=script&lang=js&"
export * from "./CreatedInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CreatedInvoice.vue?vue&type=style&index=0&id=16a50787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a50787",
  null
  
)

export default component.exports